import React from "react";
import {
  Grid,
  Typography,
  Link,
  Stack,
  Container,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

export const Footer = () => {
  const navigate = useNavigate();

  return (<Container maxWidth="md">
    <Grid container marginY={4} spacing={2} justifyContent="center">
      <Grid item xs={12} sm={7}>
        <Typography variant="h6" color="textSecondary" gutterBottom>
          About
        </Typography>
        <Typography variant="body2" color="textSecondary">
          Learn more about EchoBud, our mission, and our services.
        </Typography>
      </Grid>
      <Grid item xs={12} sm={3}>
        <Stack spacing={1}>
          <Typography variant="h6" color="textSecondary" gutterBottom>
            Policies
          </Typography>
          <Typography variant="body2" color="textSecondary">
            <Link color="secondary"
                  href={"#"}
                  onClick={() => (navigate("/privacy-policy"))}>
              Privacy Policy
            </Link>
          </Typography>
          <Typography variant="body2" color="textSecondary">
            <Link color="secondary"
                  href={"#"}
                  onClick={() => (navigate("/terms"))}>
              Terms of Service
            </Link>
          </Typography>
          <Typography variant="body2" color="textSecondary">
            <Link color="secondary"
                  href={"#"}
                  onClick={() => (navigate("/data-deletion"))}>
              Data Deletion
            </Link>
          </Typography>
        </Stack>
      </Grid>
      <Grid item xs={12} sm={2}>
        <Stack spacing={1}>
          <Typography variant="h6" color="textSecondary" gutterBottom>
            Support
          </Typography>
          <Typography variant="body2" color="textSecondary">
            <Link color="secondary"
                  href={"#"}
                  onClick={() => (navigate("/contact"))}>
              Contact Us
            </Link>
          </Typography>
        </Stack>
      </Grid>
    </Grid>
  </Container>);
};
